import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import { BMapLoader } from '@/utils/bdMap.js';
import { Notify } from 'vant';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, getFileStatus, formatToLine } from "@/utils/utils";
import { isHasLinkHandle, navigationUrl, getlastclickmarker, isMobile, getStr } from '@/view/map/js/common';
import axios from 'axios';
export default {
  // standardappmap
  name: 'xjwhgsdAmap',
  meta: {
    title: '地图'
  },
  data() {
    return {
      activeName: 0,
      activeIndex: 0,
      map: '',
      requestType: '',
      bottompopshow: true,
      // 滑动bar相关字段
      startY: 0,
      endY: 0,
      distanceY: 0,
      flag: 1,
      popHeight: '20rem',
      contentHeight: '16.8rem',
      // 搜索相关字段
      formKey: 0,
      searchinput: '',
      searchplaceholder: '请搜索',
      // 获取标签表单数据
      formparams: {
        deptId: '',
        formId: '349949',
        page: 1,
        limit: 100,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder'
      },
      tabsData: [],
      // 当前标签表单对应列表数据
      dataparams: {
        fid: '',
        formId: '',
        page: 1,
        limit: 20,
        // searchStr: '',
        latitude: '',
        longitude: '',
        orderType: 3,
        name: '',
        type: '',
        type2: ''
      },
      // 当前列表信息相关字段
      datatotalPage: 1,
      datatotal: 0,
      dataList: [],
      currentPage: 1,
      currenIndex: 0,
      currendata: {},
      currentlistparams: [],
      currentdetailparams: [],
      currentlocationparam: '',
      currentlinkparam: '',
      crrrentstructData: [],
      currentTypeData: [],
      // 当前详情信息相关字段
      detailflag: false,
      infoDetail: {},
      isHasNav: '',
      infoDetailflag: false,
      otherinfo: [],
      condition: {
        model: 0,
        filters: []
      },
      loading: false,
      finished: false,
      finishednodatatext: '已经到底啦',
      finishedtext: '已经到底啦',
      nodata: false,
      selectmultiObj: {},
      typeDomtimer: null,
      scbtnflag: false,
      scflag: false,
      onceflag: '',
      orderType: [{
        id: 3,
        label: '全部'
      }, {
        id: 1,
        label: '离我最近'
      }],
      orderTypeIndex: 0,
      location: ''
    };
  },
  created() {
    if (isMobile()) location.href = location.href.replace('standardmap', 'appmap');
  },
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('body').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    this.formparams.deptId = this.$route.query.fid;
    // this.getTabsData()
    this.getAMap();
  },
  watch: {
    infoDetail(val) {
      if (val) {
        //console.log(val)
        // this.otherinfo = val.filter((item, index) => {
        //     return (index > 1 && item !== '')
        // })
      }
    }
  },
  methods: {
    // 初始化百度地图
    getAMap() {
      BMapLoader().then(BMap => {
        this.loadMap(BMap);
        this.getTabsData();
      });
    },
    loadMap(BMap) {
      this.map = new BMap.Map('map', {
        enableMapClick: false
      });
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(a => {
        this.location = a;
        this.dataparams.latitude = a.latitude;
        this.dataparams.longitude = a.longitude;
        this.point = new BMap.Point(a.point.lng, a.point.lat);
        this.map.centerAndZoom(this.point, 15);
      });
      // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
      this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    },
    getTabsData() {
      let that = this;
      this.formparams.deptId = this.$route.query.fid;
      this.$api.singleadvanceSearch(this.formparams).then(res => {
        let formData = [];
        let titleArr = [];
        that.loading = false;
        if (res.totalRow > 0) {
          let getSindex = 0;
          formData = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata.index = index.toString();
            if (itemformat.typeparams !== '') {
              let typeArr = itemformat.typeparams.split(',');
              let typeData = [];
              typeArr.forEach((types, typesindex) => {
                let type = types.split('|');
                //console.log(type)
                typeData.push({
                  title: type[0],
                  param: type[1],
                  options: [],
                  index: '',
                  compt: ''
                });
              });

              // 获取对应表单字段结构
              let params = {
                deptId: itemformat.unitfid,
                formId: itemformat.unitformId
              };
              this.$api.formStruct(params).then(res => {
                getSindex++;
                if (res.length > 0) {
                  that.crrrentstructData = res;
                  //console.log(typeData)
                  typeData.forEach(typeitem => {
                    //console.log(typeitem.param)
                    res.forEach(stuctitem => {
                      if (typeitem.param === stuctitem.alias) {
                        // console.log(stuctitem)
                        typeitem.options = stuctitem.field.options;
                        typeitem.compt = stuctitem.compt;
                        that.selectmultiObj[typeitem.param] = [];
                      }
                    });
                  });
                  item.itemformdata.typeData = typeData;
                }
              });
            }
            // console.log(item.itemformdata)
            that.tabsData.push(item.itemformdata);
            titleArr.push(itemformat.title);
            return item;
          });
          console.log(that.tabsData);
          that.searchplaceholder += titleArr.join('、');
          if (that.tabsData[0].selectcondition !== undefined && that.tabsData[0].selectcondition !== '') {
            let selectcondition = JSON.parse(that.tabsData[0].selectcondition);
            // console.log(selectcondition)
            let confilters = [];
            selectcondition.forEach(items => {
              if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
                items.val = [items.val];
              }
              confilters.push([items]);
            });
            that.condition.filters = confilters;
            // that.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(that.condition)) : ''
          }
          // 解决表单结构字段接口数据未获取到问题
          this.timer = setInterval(() => {
            if (getSindex === res.dataList.length) {
              clearInterval(that.timer);
              that.defaultsearchparams(that.tabsData[0]);
              console.log(that.tabsData[0]);
              // 通用地图基础配置 是否存在数据
              if (that.tabsData[0][44] && that.tabsData[0][44] !== '') {
                // that.isHasTitle = true
                // that.basicformUserId = that.tabsData[0].form[44]
                let form = {
                  deptId: this.$route.query.fid,
                  formId: 677917,
                  limit: 20,
                  searchStr: ''
                };
                this.$api.singleadvanceSearch(form).then(res => {
                  res.dataList.map(elem => {
                    let itemformdata = elem.formIdValueData;
                    let itemformat = {};
                    Object.keys(itemformdata).forEach(key => {
                      itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
                    });
                    elem.itemformdata = itemformat;
                    if (elem.id === parseInt(that.tabsData[0][44])) {
                      console.log(elem);
                      // 网页标题
                      if (elem.itemformdata.toptitle && elem.itemformdata.toptitle !== '') {
                        document.title = elem.itemformdata.toptitle;
                      }
                      // 搜索自定义
                      if (elem.itemformdata.searchtitle.length !== 0 && elem.itemformdata.searchtitle !== '') {
                        that.searchplaceholder = elem.itemformdata.searchtitle;
                      }
                      // 颜色自定义
                      if (elem.itemformdata.jsontxt) {
                        let jsontxt = JSON.parse(getStr(elem.itemformdata.jsontxt));
                        document.documentElement.style.setProperty('--basic-maptheme', jsontxt.styleOption.themecolor);
                      }
                    }
                    return elem;
                  });
                });
              }
            }
          }, 500);
        }
      });
    },
    /* 获取列表数据前 坐标点的判断 */
    onload() {
      // console.log(this.dataList)
      this.getList();
    },
    // 默认搜索字段
    defaultsearchparams(current) {
      console.log(this.condition);
      this.dataparams.fid = current.unitfid;
      this.dataparams.formId = current.unitformId;
      this.dataparams.page = 1;
      this.currentlistparams = current.listparams.split(',');
      this.currentdetailparams = current.detailparams.split(',');
      this.currentlocationparam = current.locationparam;
      this.currentlinkparam = current.linkparam;
      this.currentTypeData = current.typeData;
      console.log(current);
      this.getList();
    },
    orderTypeChange(item, index) {
      this.orderTypeIndex = index;
      this.dataparams.orderType = item.id;
      this.dataparams.latitude = item.id === 1 ? this.location.latitude : '';
      this.dataparams.longitude = item.id === 1 ? this.location.longitude : '';
      this.defaultsearchparams(this.tabsData[this.activeName]);
    },
    getList() {
      let that = this;
      console.log(this.dataparams);
      axios({
        url: 'https://wly-backend.chaoxing.com/api/micro-backend/front/search/list/order',
        method: 'post',
        headers: {
          'content-type': 'application/json; charset=utf-8'
        },
        params: this.dataparams
      }).then(res => {
        let formData = [];
        console.log(res);
        let total = res.data.data.total;
        that.datatotalPage = Math.ceil(total / that.dataparams.limit);
        if (total > 0) {
          that.nodata = false;
          that.loading = false;
          that.finished = false;
          formData = res.data.data.rows.map((item, index) => {
            let sortindex = that.dataparams.limit * (that.dataparams.page - 1) + (index + 1);
            item.sortindex = sortindex;
            item.distance = item.distance ? (Math.round(item.distance / 100) / 10).toFixed(2) + 'km' : '';
            if (item.cover) item.cover = handleHttp(item.cover);
            return item;
          });
          that.datatotal = total;
          if (that.datatotalPage === 1) {
            that.dataList = formData;
            that.finished = true;
            that.finishedtext = that.finishednodatatext;
          } else {
            if (that.dataparams.page === 1) {
              that.dataList = formData;
            } else {
              that.dataList = that.dataList.concat(formData);
              if (that.dataparams.page === that.datatotalPage) {
                that.finished = true;
                that.finishedtext = that.finishednodatatext;
              }
            }
            that.dataparams.page++;
          }
          that.createMarker();
        } else {
          that.dataList = [];
          that.datatotal = total;
          that.finished = true;
          that.finishedtext = '';
          that.nodata = true;
          that.map.clearOverlays();
        }
        // setTimeout(() => {
        //     that.scflag = true
        // }, 1000)
      });
    },
    createMarker() {
      if (this.dataparams.page === 1) this.map.clearOverlays();
      let marker = null;
      let list = this.dataList;
      console.log(list);
      let bPoints = [];
      if (list.length > 0) {
        for (let i in list) {
          let point = list[i];
          if (point.location && point.location.lat) {
            let Bpoint = new BMapGL.Point(point.location.lon, point.location.lat);
            bPoints.push(Bpoint);
            // 创建文本标注
            marker = new BMapGL.Label('<span class="pointMarker">' + point.sortindex + '</span>', {
              position: Bpoint
            });
            marker.addEventListener('click', this.markerClickHandler);
            marker.sid = point.id;
            this.map.addOverlay(marker);
          }
        }
        let _this = this;
        setTimeout(function () {
          _this.setZoom(bPoints);
        }, 1000);
      }
    },
    setZoom(bPoints) {
      let view = this.map.getViewport(eval(bPoints));
      let mapZoom = view.zoom;
      let centerPoint = view.center;
      this.map.centerAndZoom(centerPoint, mapZoom);
    },
    // 坐标点点击事件
    markerClickHandler(event) {
      //   console.log(event.target)
      this.fnInitSiteInfo(event.target);
    },
    fnInitSiteInfo(target) {
      this.infoDetail = {};
      for (let i in this.dataList) {
        if (this.dataList[i].id === target.sid) {
          let item = this.dataList[i];
          this.currendata = item;
          this.infoDetail = item;
          let infocontent = this.$refs.infoBox;
          this.map.setCenter(target.getPosition());
          let infoWindow = new BMapGL.InfoWindow(infocontent, {
            width: 300
          });
          this.map.openInfoWindow(infoWindow, target.getPosition());
          this.infoDetailflag = true;
        }
      }
    },
    mapinfopoint() {
      console.log(this.currendata);
      // url=xjwhg20240402&formAlias=1354509
      let pageId = this.currentlinkparam.split(',')[1];
      window.open(`${decodeURIComponent(this.$route.query.relationto)}/page/${pageId}/${this.currendata.formUserId}/form`);
    },
    itemnavigation(val) {
      navigationUrl(val);
    },
    getLastClickMarker(markerId) {
      return getlastclickmarker(this.map, markerId);
    },
    // 点击列表触发
    listpoint(val) {
      // 是否有外链
      // console.log(val)
      let currentTarget = this.getLastClickMarker(val.id);
      if (currentTarget) {
        this.fnInitSiteInfo(currentTarget);
      } else {
        isHasLinkHandle(this.currentlinkparam, val);
      }
    },
    // tab标签点击事件
    handleClick(val) {
      console.log(val);
      this.activeName = val.title;
      this.activeIndex = val;
      this.currentPage = 1;
      let index = val;
      this.scbtnflag = false;
      this.scflag = false;
      this.currentTypeData = this.tabsData[index].typeData;
      if (this.currentTypeData !== undefined) {
        this.currentTypeData = this.currentTypeData.map(item => {
          item.index = '';
          return item;
        });
      }
      let selectcondition = '[]';
      if (this.tabsData[index].selectcondition !== undefined && this.tabsData[index].selectcondition !== '[]') {
        selectcondition = JSON.parse(this.tabsData[index].selectcondition);
        // console.log(selectcondition)
        let confilters = [];
        selectcondition.forEach(items => {
          if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
            items.val = [items.val];
          }
          confilters.push([items]);
        });
        this.condition.filters = confilters;
      }
      console.log(this.condition.filters);
      if (this.searchinput !== '') {
        this.searchStruct(this.tabsData[index]);
        return;
      }
      // this.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(this.condition)) : ''
      this.defaultsearchparams(this.tabsData[index]);
    },
    // 清除搜索文本触发
    searchdelete() {
      this.searchinput = '';
      this.activeName = 0;
      this.activeIndex = 0;
      this.dataparams.name = '';
      this.orderTypeIndex = 0;
      this.dataparams.orderType = 3;
      // if (this.tabsData[0].selectcondition !== undefined && this.tabsData[0].selectcondition !== '') {
      //     let selectcondition = JSON.parse(this.tabsData[0].selectcondition)
      //     // console.log(selectcondition)
      //     let confilters = []
      //     selectcondition.forEach(items => {
      //         if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
      //             items.val = [items.val]
      //         }   
      //         confilters.push([items])
      //     })
      //     this.condition.filters = confilters
      //     this.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(this.condition)) : ''
      // }
      // this.dataparams.searchStr = this.condition
      // this.dataparams.searchStr = encodeURI(JSON.stringify(this.dataparams.searchStr))
      this.defaultsearchparams(this.tabsData[0]);
    },
    // 搜索
    searchname() {
      let params = this.tabsData[parseInt(this.activeIndex)];
      console.log(`this.searchinput`, this.searchinput);
      this.dataparams.name = this.searchinput;
      this.orderTypeIndex = 0;
      this.dataparams.orderType = 3;
      if (this.currentTypeData.length > 0) {
        this.currentTypeData.forEach(elem => {
          elem.index = '';
        });
      }
      this.searchStruct(params);
    },
    searchStruct(val) {
      let that = this;
      let params = {
        deptId: val.unitfid,
        formId: val.unitformId
      };
      this.$api.formStruct(params).then(res => {
        let searchitem = val.listparams.split(',')[1];
        let searchalias = searchitem.split('|')[1];
        if (res.length > 0) {
          that.crrrentstructData = res;
          res.forEach(item => {
            if (item.alias === searchalias) {
              let searcharr = [{
                "alias": item.alias,
                "compt": item.compt,
                "express": "like",
                "id": 0,
                "val": that.searchinput
              }];
              let isHasSearchparams = that.condition.filters.filter(items => {
                return items[0].id === 0;
              });
              console.log(isHasSearchparams);
              if (isHasSearchparams.length > 0) {
                that.condition.filters.forEach(items => {
                  if (items[0].id === 0) items[0].val = that.searchinput;
                });
              } else {
                that.condition.filters.push(searcharr);
              }
              // that.dataparams.searchStr = that.condition
              // that.dataparams.searchStr = encodeURI(JSON.stringify(that.dataparams.searchStr))
              that.dataparams.type = '';
              that.dataparams.type2 = '';
              that.defaultsearchparams(val);
            }
          });
        }
      });
    },
    // 类型选择
    selectType(alias, title, opindex, index, compt, item) {
      console.log(`alias`, alias);
      console.log(`title`, title);
      console.log(`item`, item);

      // 处理复选类型 选中状态
      if (item !== undefined) {
        if (this.selectmultiObj[alias] && this.selectmultiObj[alias].indexOf(opindex) !== -1) {
          this.selectmultiObj[alias].splice(this.selectmultiObj[alias].indexOf(opindex), 1);
        } else {
          if (!this.selectmultiObj[alias]) this.selectmultiObj[alias] = [];
          this.selectmultiObj[alias].push(opindex);
        }
      }
      if (title === '' && this.selectmultiObj[alias]) this.selectmultiObj[alias] = [];
      // 选中当前类型
      this.currentTypeData = this.currentTypeData.map((items, indexs) => {
        if (items.param === alias) {
          items.index = opindex;
        }
        return items;
      });
      console.log(`currentTypeData`, this.currentTypeData);
      // 选中后拼凑搜索字段
      if (this.condition.filters.length > 0) {
        let isHasAlias = this.condition.filters.filter((items, indexs) => {
          return items[0].alias === alias;
        });
        if (isHasAlias.length > 0) {
          if (title !== '') {
            if (compt === 'selectbox') {
              isHasAlias[0][0].val = [title];
            } else {
              isHasAlias[0][0].val.indexOf(title) !== -1 ? isHasAlias[0][0].val.splice(isHasAlias[0][0].val.indexOf(title), 1) : isHasAlias[0][0].val.push(title);
            }
          } else {
            this.condition.filters = this.condition.filters.filter((items, indexs) => {
              return items[0].alias !== alias;
            });
          }
        } else {
          this.condition.filters.push([{
            "alias": alias,
            "compt": compt,
            "express": compt === "selectbox" ? "===" : "match",
            "id": index + 1,
            "val": [title]
          }]);
        }
      } else {
        if (title !== '') {
          this.condition.filters.push([{
            "alias": alias,
            "compt": compt,
            "express": compt === "selectbox" ? "===" : "match",
            "id": index + 1,
            "val": [title]
          }]);
        }
      }
      let activeName = parseInt(this.activeName);
      if (alias === '16') this.dataparams.type = title;
      if (alias === '20') this.dataparams.type2 = title;
      // this.dataparams.searchStr = this.condition
      // this.dataparams.searchStr = encodeURI(JSON.stringify(this.dataparams.searchStr))
      this.defaultsearchparams(this.tabsData[this.activeName]);
    },
    /* 滑动触摸开始事件 */
    handleTouchStart(e) {
      this.endY = e.touches[0].pageY;
    },
    /* 滑动触摸滑动事件 */
    handleTouchMove(e) {
      this.startY = e.touches[0].pageY;
    },
    /* 滑动触摸结束事件 */
    handleTouchEnd(e) {
      this.distanceY = this.startY - this.endY;
      if (this.distanceY > 0 && Math.abs(this.distanceY) >= 50) {
        if (this.flag >= 1) return;
        this.flag++;
        if (this.flag === 1) {
          this.popHeight = '20rem';
          this.contentHeight = '16.8rem';
        }
      } else if (this.distanceY < 0 && Math.abs(this.distanceY) >= 50) {
        if (this.flag < 0) return;
        this.flag--;
        if (this.flag === 0) {
          this.popHeight = '33rem';
          this.contentHeight = '29.3rem';
        }
      }
    }
  }
};